// Melinam bundle deals: toggle items, switch variants, keep the total in sync, add all selected to cart.
if (!customElements.get('mel-bundle')) {
  customElements.define('mel-bundle', class extends HTMLElement {
    connectedCallback() {
      this.products = [...this.querySelectorAll('.mel-bundle__product')];
      this.querySelectorAll('.mel-bundle__check').forEach(c => c.addEventListener('change', () => this.refresh()));
      this.querySelectorAll('.mel-bundle__variant').forEach(s => s.addEventListener('change', e => this.onVariant(e.target)));
      const add = this.querySelector('.mel-bundle__add');
      if (add) add.addEventListener('click', () => this.addToCart(add));
    }
    money(cents) {
      const fmt = this.dataset.moneyFormat || '{{amount}}';
      const n = Math.max(0, Math.round(cents)) / 100;
      const withSep = (v, d, t, dec) => { const [i, f] = v.toFixed(d).split('.'); return i.replace(/\B(?=(\d{3})+(?!\d))/g, t) + (f ? dec + f : ''); };
      return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => ({
        amount: withSep(n, 2, ',', '.'), amount_no_decimals: withSep(n, 0, ',', '.'),
        amount_with_comma_separator: withSep(n, 2, '.', ','), amount_no_decimals_with_comma_separator: withSep(n, 0, '.', ','),
      }[k] || withSep(n, 2, ',', '.')));
    }
    onVariant(select) {
      const product = select.closest('.mel-bundle__product');
      const opt = select.selectedOptions[0];
      const check = product.querySelector('.mel-bundle__check');
      check.dataset.variant = opt.value;
      check.dataset.price = opt.dataset.price;
      check.dataset.compare = opt.dataset.compare;
      product.querySelector('.mel-bundle__price').textContent = this.money(+opt.dataset.price);
      const cmp = product.querySelector('.mel-bundle__compare');
      if (cmp) cmp.textContent = +opt.dataset.compare > +opt.dataset.price ? this.money(+opt.dataset.compare) : '';
      this.refresh();
    }
    refresh() {
      let total = 0, compare = 0;
      this.products.forEach(p => {
        const c = p.querySelector('.mel-bundle__check');
        p.classList.toggle('is-off', !c.checked);
        const media = this.querySelector(`.mel-bundle__media-item[data-index="${p.dataset.index}"]`);
        if (media) media.classList.toggle('is-off', !c.checked);
        if (c.checked) { total += +c.dataset.price; compare += +c.dataset.compare; }
      });
      if (this.dataset.updatePrices !== 'true') return;
      total = total * parseFloat(this.dataset.pctLeft || 1) - parseFloat(this.dataset.fixed || 0);
      const t = this.querySelector('.mel-bundle__total-price'), tc = this.querySelector('.mel-bundle__total-compare');
      if (t) t.textContent = this.money(total);
      if (tc) tc.textContent = compare > total ? this.money(compare) : '';
    }
    async addToCart(button) {
      const items = [...this.querySelectorAll('.mel-bundle__check:checked')].map(c => ({ id: +c.dataset.variant, quantity: 1 }));
      const err = this.querySelector('.mel-bundle__error');
      if (!items.length) return;
      button.setAttribute('aria-busy', 'true');
      button.disabled = true;
      try {
        const res = await fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }),
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart');
        window.location.href = this.dataset.skipCart === 'true' ? '/checkout' : (window.routes && window.routes.cart_url) || '/cart';
      } catch (e) {
        if (err) { err.textContent = e.message; err.hidden = false; }
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    }
  });
}
